var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _dec7, _dec8, _class2, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _dec9, _class3, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import ModelTraits from "../ModelTraits";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
export let SearchParameterTraits = (_dec = primitiveTrait({
  type: "string",
  name: "id",
  description: "ID of the search parameter"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Name",
  description: "A human readable name for the search parameter"
}), _dec3 = anyTrait({
  name: "queryOptions",
  description: "Options used when querying the parameter, these options will be passed to the index used for querying the parameter."
}), _class = class SearchParameterTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "id", _descriptor, this);
    _initializerDefineProperty(this, "name", _descriptor2, this);
    _initializerDefineProperty(this, "queryOptions", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "queryOptions", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let ItemSearchTraits = (_dec4 = primitiveTrait({
  type: "string",
  name: "providerType",
  description: "The type of the search provider."
}), _dec5 = anyTrait({
  name: "providerOptions",
  description: "Options for the search provider."
}), _dec6 = primitiveTrait({
  type: "string",
  name: "resultTemplate",
  description: "Template string to format the item result. You can pass a mustache template and refer to variables in {@ItemSearchResult.properties}. The template can also have HTML markup or markdown formatting."
}), _dec7 = primitiveTrait({
  type: "string",
  name: "highlightColor",
  description: "A color to use for highlighting the selected result. Defaults to {@HighlightColorTraits.highlightColor} or {@Terria.baseMapContrastColor}"
}), _dec8 = objectArrayTrait({
  type: SearchParameterTraits,
  name: "Search parameters",
  description: "Search parameter configurations",
  idProperty: "id"
}), _class2 = class ItemSearchTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "providerType", _descriptor4, this);
    _initializerDefineProperty(this, "providerOptions", _descriptor5, this);
    _initializerDefineProperty(this, "resultTemplate", _descriptor6, this);
    _initializerDefineProperty(this, "highlightColor", _descriptor7, this);
    _initializerDefineProperty(this, "parameters", _descriptor8, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "providerType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "providerOptions", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "resultTemplate", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "highlightColor", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "parameters", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let SearchableItemTraits = (_dec9 = objectTrait({
  type: ItemSearchTraits,
  name: "search",
  description: "Item search configuration"
}), _class3 = class SearchableItemTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "search", _descriptor9, this);
  }
}, _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "search", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export { SearchableItemTraits as default };